import { InvoiceLineType } from '@features/invoices/enums/invoiceLineType'
import type { InvoiceFormRowLine } from '@features/invoices/types/invoiceForm/invoiceFormLine/invoiceFormRowLine'
import { ProductType } from '@features/products/enums/productType'
import { ProductUnit } from '@features/products/enums/productUnit'

export const demoInvoicingSettingsInvoiceLine: InvoiceFormRowLine = {
  date: new Date(),
  discount: 0,
  productName: '',
  productType: ProductType.Goods,
  quantity: 1,
  totalExcludingVat: 0,
  totalIncludingVat: 0,
  type: InvoiceLineType.Row,
  unit: ProductUnit.Hour,
  unitPrice: 0,
  vatRateId: 's_fr_100',
  vatRatePercent: 0.1,
}
